<template>
  <div
    class="border-surface-200 inline-flex shrink-0 rounded-lg border bg-white p-1 shadow-sm"
  >
    <button
      v-for="l in locales"
      :key="l"
      type="button"
      class="whitespace-nowrap rounded-md px-2 py-1.5 text-xs font-medium transition-colors disabled:cursor-not-allowed sm:px-3 sm:text-sm"
      :class="[
        l === locale
          ? 'bg-primary-600 text-white'
          : 'text-surface-500 hover:bg-surface-100 cursor-pointer',
        isLocaleLocked && l !== locale && 'opacity-40 hover:bg-transparent',
      ]"
      :disabled="isLocaleLocked"
      :title="
        isLocaleLocked
          ? t('languageSwitcher.lockedDuringSession')
          : t(`languageSwitcher.${l}`)
      "
      :aria-label="t(`languageSwitcher.${l}`)"
      @click="setLocale(l)"
    >
      <!-- One character on phones, where the header is tight (Kelvin,
           2026-10-15) -->
      <span class="sm:hidden" aria-hidden="true">{{ SHORT_LABELS[l] }}</span>
      <span class="hidden sm:inline">{{ t(`languageSwitcher.${l}`) }}</span>
    </button>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import { isLocaleLocked, type Locale, locales, setLocale } from '@/i18n';

const { t, locale } = useI18n();

const SHORT_LABELS: Record<Locale, string> = { en: 'EN', yue: '繁', cmn: '简' };
</script>
